var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{attrs:{"title":_vm.title,"description":_vm.description,"round":_vm.round,"actions":_vm.list,"cancel-text":_vm.cancelText,"close-on-click-action":_vm.closeOnClickAction,"get-container":"body"},on:{"cancel":_vm.onCancel,"select":_vm.onSelect},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }